<template>
  <v-col cols="12">
    <!-- ======= FILTROS ======= -->
    <v-col cols="12">
      <v-col cols="12">
        <div class="d-flex flex-wrap justify-center align-center">

          <datePicker v-model="filtros.desde" format="YYYY-MM-DD" label="Desde" clearable maxToday @input="buscar"
            hide-details dense class="mr-1 mb-1" />

          <datePicker v-model="filtros.hasta" format="YYYY-MM-DD" label="Hasta" clearable maxToday
            :minDate="filtros.desde" @input="buscar" hide-details dense class="mr-1 mb-1" />

          <!-- <v-autocomplete v-model="filtros.tipoBusqueda" :items="tiposBusqueda" item-text="value" item-value="id"
            label="Tiempo a concierar" clearable hide-details dense class="mr-1 mb-1" /> -->

          <v-autocomplete v-model="filtros.idMaquinasIns" :items="maquinaIns" :item-text="nombreMaquina"
            item-value="idMaquinaIns" label="Máquinas" multiple chips small-chips deletable-chips clearable
            :loading="loadingInstancias" hide-details dense class="mr-1 mb-1" />

          <!-- <v-autocomplete v-if="filtros.tipoBusqueda === 2" v-model="filtros.moldes" :items="moldes" item-text="codigo" item-value="idMolde"
            label="Moldes" multiple chips small-chips deletable-chips clearable :loading="loadingMoldes" hide-details
            dense class="mr-1 mb-1" /> -->

          <!-- Unidad (se conserva para no romper layout) -->
          <v-btn-toggle v-if="false" v-model="unidad" dense class="mr-1 mb-1" mandatory group>
            <v-btn color="primary" value="s" small>Segundos</v-btn>
            <v-btn color="primary" value="min" small>Minutos</v-btn>
          </v-btn-toggle>

          <v-btn :loading="loadingBusqueda" :disabled="!filtros.desde || !filtros.hasta" color="primary"
            class="mb-1" @click="buscar()">Buscar</v-btn>

          <v-btn v-if="false" color="secondary" text class="mb-1" @click="resetFiltros()">Reset</v-btn>
        </div>

        <v-progress-linear v-if="loadingBusqueda" indeterminate height="2" color="primary" class="mt-2" />
      </v-col>
    </v-col>

    <!-- ======= KPIs ======= -->
    <v-row class="mt-4" dense>
      <v-col cols="12" sm="3">
        <v-card outlined>
          <v-card-text class="text-center">
            <div class="caption mb-1">Cambios (En rango)</div>
            <div class="display-1 font-weight-bold">{{ resumen.totalCambios }}</div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="3">
        <v-card outlined>
          <v-card-text class="text-center">
            <div class="caption mb-1">Duración promedio</div>
            <div class="display-1 font-weight-bold">
              {{ resumen.totalCambios ? formatearUnidad(resumen.duracionPromedioSeg) : 'Sin datos' }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="3">
        <v-card outlined>
          <v-card-text class="text-center">
            <div class="caption mb-1">Duración mínima</div>
            <div class="display-1 font-weight-bold">
              {{ resumen.totalCambios ? formatearUnidad(resumen.duracionMinSeg) : 'Sin datos' }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="3">
        <v-card outlined>
          <v-card-text class="text-center">
            <div class="caption mb-1">Duración máxima</div>
            <div class="display-1 font-weight-bold">
              {{ resumen.totalCambios ? formatearUnidad(resumen.duracionMaxSeg) : 'Sin datos' }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ======= RESUMEN POR MÁQUINA (usa CambioMoldesCard) ======= -->
    <v-row class="mt-2" dense>
      <v-col cols="12">
        <!-- Le pasamos exactamente el shape que espera: { cambiosPorMaquina: [...] } -->
        <CambioMoldesCard :data="{ cambiosPorMaquina: cambiosPorMaquina }" :peorPrimeroDefault="true" />
      </v-col>
    </v-row>

    <!-- ======= HISTÓRICO ======= -->
    <v-row class="mt-2" dense v-if="false">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="subtitle-1">Histórico de cambios</v-card-title>
          <v-data-table :headers="headersTabla" :items="cambios" dense :items-per-page="10" class="elevation-0">
            <template #item.deA="{ item }">
              {{ (item.moldeDe || '—') + ' → ' + item.moldeA }}
            </template>
            <template #item.duracionSeg="{ item }">
              {{ formatearUnidad(item.duracionSeg) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ======= DIALOG DETALLES (se conserva) ======= -->
    <v-dialog v-model="dialogDetalle" max-width="1000px">
      <v-card>
        <v-card-title class="headline">
          Detalles — {{ detalleSel ? detalleSel.maquina : '' }}
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="3">
              <div class="caption">Cambios</div>
              <div class="title font-weight-bold">{{ detalleSel ? detalleSel.cambios : 0 }}</div>
            </v-col>
            <v-col cols="12" sm="3">
              <div class="caption">Promedio</div>
              <div class="title font-weight-bold">{{ detalleSel ? formatearUnidad(detalleSel.promedioSeg) : '0 s' }}
              </div>
            </v-col>
            <v-col cols="12" sm="3">
              <div class="caption">Mínimo</div>
              <div class="title font-weight-bold">{{ detalleSel ? formatearUnidad(detalleSel.minSeg) : '0 s' }}</div>
            </v-col>
            <v-col cols="12" sm="3">
              <div class="caption">Máximo</div>
              <div class="title font-weight-bold">{{ detalleSel ? formatearUnidad(detalleSel.maxSeg) : '0 s' }}</div>
            </v-col>
          </v-row>

          <v-subheader class="mt-4">Rendimiento por molde (destino)</v-subheader>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Molde</th>
                <th class="text-right">Cambios</th>
                <th class="text-right">Promedio</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in detalleMoldes" :key="r.molde">
                <td>{{ r.molde }}</td>
                <td class="text-right">{{ r.cambios }}</td>
                <td class="text-right">{{ formatearUnidad(r.promSeg) }}</td>
              </tr>
              <tr v-if="!detalleMoldes.length">
                <td colspan="3" class="grey--text">Sin datos</td>
              </tr>
            </tbody>
          </v-simple-table>

          <v-subheader class="mt-4">Histórico de la máquina</v-subheader>
          <v-data-table :headers="headersTablaDetalle" :items="cambiosDetalle" dense :items-per-page="8"
            class="elevation-0">
            <template #item.deA="{ item }">
              {{ (item.moldeDe || '—') + ' → ' + item.moldeA }}
            </template>
            <template #item.duracionSeg="{ item }">
              {{ formatearUnidad(item.duracionSeg) }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDetalle = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import axios from 'axios'
import CambioMoldesCard from './CambioMoldesCard.vue' // <- importa el componente

export default {
  components: { CambioMoldesCard },

  data() {
    return {
      // Filtros
      filtros: { desde: null, hasta: null, tipoBusqueda: null, idMaquinasIns: [], moldes: [] },

      // UI/config
      unidad: 's',
      maxSegundosEntreCambios: 100600,

      // Catálogos
      maquinaIns: [],
      moldes: [],
      loadingInstancias: false,
      loadingMoldes: false,
      loadingBusqueda: false,

      // Datos
      instancias: [],
      resumen: {
        maquinasActivas: 0,
        totalCambios: 0,
        duracionPromedioSeg: 0,
        duracionMinSeg: 0,
        duracionMaxSeg: 0,
        p95Seg: 0
      },
      cambios: [],
      tiposBusqueda: [
        { id: 1, value: "Tiempo entre ODT" },
        { id: 2, value: "Tiempo entre Moldes" },
      ],

      // Dialog Detalles
      dialogDetalle: false,
      detalleSel: null
    }
  },
  computed: {
    headersTabla() {
      return [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Máquina', value: 'maquina' },
        { text: 'De → A', value: 'deA' },
        { text: 'Inicio', value: 'inicio' },
        { text: 'Fin', value: 'fin' },
        { text: 'Duración', value: 'duracionSeg' }
      ]
    },
    headersTablaDetalle() {
      return [
        { text: 'Fecha', value: 'fecha' },
        { text: 'De → A', value: 'deA' },
        { text: 'Inicio', value: 'inicio' },
        { text: 'Fin', value: 'fin' },
        { text: 'Duración', value: 'duracionSeg' }
      ]
    },

    // ======= Agrupación para CambioMoldesCard (shape: cambiosPorMaquina) =======
    cambiosPorMaquina() {
      // Agrupa this.cambios por idMaquina y calcula promedio/min/max
      const mapa = new Map()
      for (const c of this.cambios) {
        let g = mapa.get(c.idMaquina)
        if (!g) {
          const m = this.maquinaIns.find(x => x.idMaquinaIns === c.idMaquina) || {}
          g = {
            idMaquinaIns: c.idMaquina,
            nombreMaquinaIns: c.maquina || m.nombreMaquinaIns || m.nombre || `Maq ${c.idMaquina}`,
            cambios: [],
            promedioSegundos: 0,
            minSegundos: Infinity,
            maxSegundos: 0,
            _sum: 0,
            _count: 0
          }
          mapa.set(c.idMaquina, g)
        }
        g.cambios.push({
          idBloqueOperacionReal: c.id,
          idMoldeInicial: c.idMoldeInicial || null,
          idMoldeFinal: c.idMoldeFinal || null,
          inicio: c.inicio,
          fin: c.fin,
          duracion: c.duracionSeg,
          etqDe: c.etqDe || c.moldeDe,
          etqA: c.etqA || c.moldeA,
          detalleDe: c.detalleDe || null,
          detalleA: c.detalleA || null
        })
        g._sum += Number(c.duracionSeg || 0)
        g._count += 1
        g.minSegundos = Math.min(g.minSegundos, Number(c.duracionSeg || 0))
        g.maxSegundos = Math.max(g.maxSegundos, Number(c.duracionSeg || 0))
      }

      const arr = []
      mapa.forEach(g => {
        const count = g._count || 0
        arr.push({
          idMaquinaIns: g.idMaquinaIns,
          nombreMaquinaIns: g.nombreMaquinaIns,
          cambios: g.cambios,
          promedioSegundos: count ? Math.round(g._sum / count) : 0,
          minSegundos: isFinite(g.minSegundos) ? g.minSegundos : 0,
          maxSegundos: g.maxSegundos || 0
        })
      })
      return arr
    },

    // ======= (Se mantiene tu resumen por máquina original para el diálogo) =======
    statsPorMaquina() {
      if (!this.cambios.length) return []
      const porMaq = new Map()
      for (const c of this.cambios) {
        if (!porMaq.has(c.idMaquina)) {
          porMaq.set(c.idMaquina, {
            idMaquina: c.idMaquina,
            maquina: c.maquina,
            sum: 0, count: 0, min: Infinity, max: -Infinity,
            moldes: new Map()
          })
        }
        const g = porMaq.get(c.idMaquina)
        g.sum += Number(c.duracionSeg || 0)
        g.count += 1
        g.min = Math.min(g.min, c.duracionSeg || 0)
        g.max = Math.max(g.max, c.duracionSeg || 0)

        const claveMolde = c.etqA || c.moldeA || '—'
        if (!g.moldes.has(claveMolde)) g.moldes.set(claveMolde, { sum: 0, count: 0 })
        const mm = g.moldes.get(claveMolde)
        mm.sum += Number(c.duracionSeg || 0)
        mm.count += 1
      }

      const out = []
      for (const [, g] of porMaq) {
        let lento = null, rapido = null
        for (const [molde, v] of g.moldes) {
          const avg = v.count ? v.sum / v.count : 0
          if (!lento || avg > lento.promSeg) lento = { molde, promSeg: avg }
          if (!rapido || avg < rapido.promSeg) rapido = { molde, promSeg: avg }
        }
        out.push({
          idMaquina: g.idMaquina,
          maquina: g.maquina,
          cambios: g.count,
          promedioSeg: g.count ? Math.round(g.sum / g.count) : 0,
          minSeg: isFinite(g.min) ? g.min : 0,
          maxSeg: isFinite(g.max) ? g.max : 0,
          moldeMasTarda: lento ? { molde: lento.molde, promSeg: Math.round(lento.promSeg) } : null,
          moldeMenosTarda: rapido ? { molde: rapido.molde, promSeg: Math.round(rapido.promSeg) } : null
        })
      }
      return out.sort(
        (a, b) =>
          (b.promedioSeg - a.promedioSeg) ||
          (b.maxSeg - a.maxSeg) ||
          (a.maquina || '').localeCompare(b.maquina || '')
      )
    },

    // Datos del diálogo
    cambiosDetalle() {
      if (!this.detalleSel) return []
      const idM = this.detalleSel.idMaquina
      return this.cambios.filter(x => x.idMaquina === idM)
    },
    detalleMoldes() {
      if (!this.detalleSel) return []
      const idM = this.detalleSel.idMaquina
      const mapa = new Map()
      for (const c of this.cambios) {
        if (c.idMaquina !== idM) continue
        const clave = c.etqA || c.moldeA || '—'
        if (!mapa.has(clave)) mapa.set(clave, { molde: clave, sum: 0, count: 0 })
        const obj = mapa.get(clave)
        obj.sum += Number(c.duracionSeg || 0)
        obj.count += 1
      }
      const arr = []
      mapa.forEach((v) => {
        arr.push({ molde: v.molde, cambios: v.count, promSeg: v.count ? Math.round(v.sum / v.count) : 0 })
      })
      return arr.sort((a, b) => b.promSeg - a.promSeg)
    }
  },
  methods: {
    // Etiquetas
    nombreMaquina: (m) => {
      const nombre = m.nombreMaquinaIns || m.nombre || ''
      const marcaModelo = [m.marca, m.modelo].filter(Boolean).join(' ')
      if (nombre && marcaModelo) return `[${nombre}] - ${marcaModelo}`
      return nombre || marcaModelo || 'Maquina'
    },
    etiquetaMaquina(id) {
      const m = this.maquinaIns.find(x => x.idMaquinaIns === id)
      return m ? this.nombreMaquina(m) : `Máquina ${id}`
    },
    etiquetaMolde(id) {
      if (id == null) return '—'
      const md = this.moldes.find(x => x.idMolde === id)
      return md ? md.codigo : `Molde ${id}`
    },
    etiquetaArticulo(nombreArticulo, codigoArticulo) {
      const n = (nombreArticulo || '').toString().trim()
      const c = (codigoArticulo || '').toString().trim()
      if (n && c && n !== c) return `${n} (${c})`
      return n || c || ''
    },
    etiquetaOperacion({ area, nombreArticulo, codigoArticulo } = {}) {
      const a = (area || '').toString().trim()
      const articulo = this.etiquetaArticulo(nombreArticulo, codigoArticulo)
      if (a && articulo) return `${a} - ${articulo}`
      if (a) return a
      if (articulo) return articulo
      return 'Sin datos'
    },
    detalleOperacion({ area, claveTrabajoOrden, nombreArticulo, codigoArticulo, inicio, fin } = {}) {
      const a = (area || '').toString().trim()
      const ot = (claveTrabajoOrden || '').toString().trim()
      const articulo = this.etiquetaArticulo(nombreArticulo, codigoArticulo)
      return {
        area: a || null,
        ot: ot || null,
        articulo: articulo || null,
        inicio: inicio || null,
        fin: fin || null
      }
    },

    abrirDetalles(m) {
      this.detalleSel = m
      this.dialogDetalle = true
    },

    // Inicialización
    initialice() { this.getInstancias(); this.getMoldes(); },

    async getInstancias() {
      this.loadingInstancias = true
      try { this.maquinaIns = (await axios.get('/MaquinaInstancias')).data }
      catch (e) { console.error(e) }
      finally { this.loadingInstancias = false }
    },
    async getMoldes() {
      this.loadingMoldes = true
      try { this.moldes = (await axios.get('/Moldes')).data }
      catch (e) { console.error(e) }
      finally { this.loadingMoldes = false }
    },

    toRepeatedQS(key, arr) { return (arr || []).map(v => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join('&') },

    async buscar() {
      if (!this.filtros.desde || !this.filtros.hasta) return
      const qsMaquinas = this.toRepeatedQS('IdMaquinaIns', this.filtros.idMaquinasIns)
      const qsMoldes = this.toRepeatedQS('IdMoldes', this.filtros.moldes)
      const params = [
        `Inicio=${encodeURIComponent(this.filtros.desde)}`,
        `Fin=${encodeURIComponent(this.filtros.hasta)}`,
        // `maxSegundosEntreCambios=${this.maxSegundosEntreCambios}`,
        `UsarParos=${encodeURIComponent(true)}`,
        (this.filtros.tipoBusqueda != null ? `tipoBusqueda=${this.filtros.tipoBusqueda}` : null),
        qsMaquinas, qsMoldes
      ].filter(Boolean).join('&')

      this.loadingBusqueda = true
      try {
        const { data } = await axios.get(`/Reportes/ReporteTiempoCambioMoldesYODT?${params}`)
        this.mapearRespuesta(data)
      } catch (err) {
        console.error(err); this.$emit('error', err)
      } finally { this.loadingBusqueda = false }
    },

    // >>>>>>>>>> MAPEO (soporta Instancias, Moldes y ODT) <<<<<<<<<<
    mapearRespuesta(data) {
      const instancias =
        (data && (data.instancias || data.Instancias)) || []
      if (Array.isArray(instancias) && instancias.length) {
        this.instancias = instancias
        const cambios = []
        instancias.forEach((inst) => {
          const idMaq = inst.idMaquinaIns != null ? inst.idMaquinaIns : inst.IdMaquinaIns
          const nombreMaq = inst.nombreMaquinaIns || inst.NombreMaquinaIns || this.etiquetaMaquina(idMaq)
          const operaciones = inst.operaciones || inst.Operaciones || []
          const opById = new Map()
          operaciones.forEach((op) => {
            const idOp = op.idOperacion != null ? op.idOperacion : op.IdOperacion
            if (idOp != null && !opById.has(idOp)) opById.set(idOp, op)
          })
          const cambiosInst = inst.cambios || inst.Cambios || []
          cambiosInst.forEach((c) => {
            const idOpIni = c.idOperacionInicial != null ? c.idOperacionInicial : c.IdOperacionInicial
            const idOpFin = c.idOperacionFinal != null ? c.idOperacionFinal : c.IdOperacionFinal
            const opIni = idOpIni != null ? opById.get(idOpIni) : null
            const opFin = idOpFin != null ? opById.get(idOpFin) : null

            const inicio = c.finOperacionInicial || c.FinOperacionInicial
            const fin = c.inicioOperacionFinal || c.InicioOperacionFinal
            let durSeg = Number(
              c.tiempoEntreOperacionesSeg != null ? c.tiempoEntreOperacionesSeg : (c.TiempoEntreOperacionesSeg != null ? c.TiempoEntreOperacionesSeg : 0)
            )
            if (!durSeg && inicio && fin) {
              const ini = new Date(inicio)
              const fi = new Date(fin)
              if (!isNaN(ini) && !isNaN(fi)) durSeg = Math.max(0, Math.round((fi - ini) / 1000))
            }
            const etqDe = this.etiquetaOperacion({
              area: c.areaInicial || c.AreaInicial,
              nombreArticulo: c.nombreArticuloInicial || c.NombreArticuloInicial,
              codigoArticulo: c.codigoArticuloInicial || c.CodigoArticuloInicial
            })
            const etqA = this.etiquetaOperacion({
              area: c.areaFinal || c.AreaFinal,
              nombreArticulo: c.nombreArticuloFinal || c.NombreArticuloFinal,
              codigoArticulo: c.codigoArticuloFinal || c.CodigoArticuloFinal
            })
            const detalleDe = this.detalleOperacion({
              area: c.areaInicial || c.AreaInicial || (opIni && (opIni.area || opIni.Area)),
              claveTrabajoOrden: c.claveTrabajoOrdenInicial || c.ClaveTrabajoOrdenInicial ||
                (opIni && (opIni.claveTrabajoOrden || opIni.ClaveTrabajoOrden)),
              nombreArticulo: c.nombreArticuloInicial || c.NombreArticuloInicial ||
                (opIni && (opIni.nombreArticulo || opIni.NombreArticulo)),
              codigoArticulo: c.codigoArticuloInicial || c.CodigoArticuloInicial ||
                (opIni && (opIni.codigoArticulo || opIni.CodigoArticulo)),
              inicio: (opIni && (opIni.inicioPrimeraOperacionReal || opIni.InicioPrimeraOperacionReal)) ||
                c.inicioOperacionInicial || c.InicioOperacionInicial || null,
              fin: (opIni && (opIni.finUltimaOperacionReal || opIni.FinUltimaOperacionReal)) ||
                c.finOperacionInicial || c.FinOperacionInicial || null
            })
            const detalleA = this.detalleOperacion({
              area: c.areaFinal || c.AreaFinal || (opFin && (opFin.area || opFin.Area)),
              claveTrabajoOrden: c.claveTrabajoOrdenFinal || c.ClaveTrabajoOrdenFinal ||
                (opFin && (opFin.claveTrabajoOrden || opFin.ClaveTrabajoOrden)),
              nombreArticulo: c.nombreArticuloFinal || c.NombreArticuloFinal ||
                (opFin && (opFin.nombreArticulo || opFin.NombreArticulo)),
              codigoArticulo: c.codigoArticuloFinal || c.CodigoArticuloFinal ||
                (opFin && (opFin.codigoArticulo || opFin.CodigoArticulo)),
              inicio: (opFin && (opFin.inicioPrimeraOperacionReal || opFin.InicioPrimeraOperacionReal)) ||
                c.inicioOperacionFinal || c.InicioOperacionFinal || null,
              fin: (opFin && (opFin.finUltimaOperacionReal || opFin.FinUltimaOperacionReal)) ||
                c.finOperacionFinal || c.FinOperacionFinal || null
            })
            cambios.push({
              id: null,
              fecha: (inicio || fin || '').slice(0, 10),
              maquina: nombreMaq,
              idMaquina: idMaq,
              moldeDe: etqDe,
              moldeA: etqA,
              etqDe,
              etqA,
              detalleDe,
              detalleA,
              inicio,
              fin,
              duracionSeg: durSeg
            })
          })
        })
        this.cambios = cambios

        // KPIs
        const durs = this.cambios.map(x => x.duracionSeg)
        const n = durs.length
        this.resumen = {
          maquinasActivas: new Set(this.cambios.map(x => x.idMaquina)).size,
          totalCambios: n,
          duracionPromedioSeg: n ? Math.round(durs.reduce((a, b) => a + b, 0) / n) : 0,
          duracionMinSeg: n ? Math.min.apply(null, durs) : 0,
          duracionMaxSeg: n ? Math.max.apply(null, durs) : 0,
          p95Seg: 0
        }
        return
      }

      this.instancias = []
      const isODT = Number(this.filtros.tipoBusqueda) === 1

      // Fuentes posibles del Back (nombres seguros)
      const arrMoldes =
        (data && (data.reporteTiempoCambioMoldesYODT || data.ReporteTiempoCambioMoldesYODT ||
                  data.reporteTiempoCambioMoldes || data.ReporteTiempoCambioMoldes)) || []
      const arrODT =
        (data && (data.reporteTiempoCambioODT || data.ReporteTiempoCambioODT)) || []

      // Elegir según filtro y fallback si viene vacío
      const src = isODT
        ? (arrODT.length ? arrODT : arrMoldes)
        : (arrMoldes.length ? arrMoldes : arrODT)

      this.cambios = (src || []).map(c => {
        const inicio = c.inicio || c.Inicio
        const fin = c.fin || c.Fin
        const durSeg = Number(c.duracion != null ? c.duracion : (c.Duracion != null ? c.Duracion : 0))
        const idMaq = c.idMaquinaIns != null ? c.idMaquinaIns : c.IdMaquinaIns

        // Normalizar “De → A”
        let idDe = null, idA = null, deLabel = '—', aLabel = '—'
        if (!isODT && (c.idMoldeInicial != null || c.IdMoldeInicial != null)) {
          idDe = c.idMoldeInicial != null ? c.idMoldeInicial : c.IdMoldeInicial
          idA  = c.idMoldeFinal   != null ? c.idMoldeFinal   : c.IdMoldeFinal
          deLabel = this.etiquetaMolde(idDe)
          aLabel  = this.etiquetaMolde(idA)
        } else {
          const toI  = c.idTrabajoOrdenInicial ?? c.IdTrabajoOrdenInicial
          const toDI = c.idTrabajoOrdenDetalleInicial ?? c.IdTrabajoOrdenDetalleInicial
          const toF  = c.idTrabajoOrdenFinal ?? c.IdTrabajoOrdenFinal
          const toDF = c.idTrabajoOrdenDetalleFinal ?? c.IdTrabajoOrdenDetalleFinal
          if (toI != null || toF != null) {
            deLabel = `ODT ${toI}${toDI != null ? ':' + toDI : ''}`
            aLabel  = `ODT ${toF}${toDF != null ? ':' + toDF : ''}`
          }
        }

        const id =
          c.idBloqueOperacionReal ?? c.IdBloqueOperacionReal ??
          ((c.idOperacionRealInicial != null || c.IdOperacionRealInicial != null)
            ? `OP${(c.idOperacionRealInicial ?? c.IdOperacionRealInicial)}->${(c.idOperacionRealFinal ?? c.IdOperacionRealFinal)}`
            : null)

        return {
          id,
          fecha: (inicio || '').slice(0, 10),
          maquina: this.etiquetaMaquina(idMaq),
          idMaquina: idMaq,
          moldeDe: deLabel,
          moldeA: aLabel,
          etqDe: deLabel,
          etqA: aLabel,
          detalleDe: this.detalleOperacion({ nombreArticulo: deLabel, inicio, fin }),
          detalleA: this.detalleOperacion({ nombreArticulo: aLabel, inicio, fin }),
          // IDs crudos (nulos en ODT)
          idMoldeInicial: idDe,
          idMoldeFinal: idA,
          inicio, fin,
          duracionSeg: durSeg
        }
      })

      // KPIs
      const durs = this.cambios.map(x => x.duracionSeg)
      const n = durs.length
      this.resumen = {
        maquinasActivas: new Set(this.cambios.map(x => x.idMaquina)).size,
        totalCambios: n,
        duracionPromedioSeg: n ? Math.round(durs.reduce((a, b) => a + b, 0) / n) : 0,
        duracionMinSeg: n ? Math.min.apply(null, durs) : 0,
        duracionMaxSeg: n ? Math.max.apply(null, durs) : 0,
        p95Seg: 0
      }
    },

    // Formato compacto "Xd Yh Zm Ws"
    formatearUnidad(seg) {
      const s = Math.max(0, Math.floor(Number(seg) || 0));
      if (s === 0) return '0 s';
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const r = s % 60;
      const parts = [];
      if (d) parts.push(d + 'd');
      if (h) parts.push(h + 'h');
      if (m) parts.push(m + 'm');
      if (r) parts.push(r + 's');
      return parts.join(' ');
    },

    resetFiltros() {
      this.filtros = { desde: null, hasta: null, tipoBusqueda: null, idMaquinasIns: [], moldes: [] }
      this.unidad = 's'
      this.maxSegundosEntreCambios = 100600
      this.instancias = []
      this.cambios = []
      this.resumen = {
        maquinasActivas: 0,
        totalCambios: 0,
        duracionPromedioSeg: 0,
        duracionMinSeg: 0,
        duracionMaxSeg: 0,
        p95Seg: 0
      }
    }
  },
  mounted() {
    this.initialice()
  }
}
</script>

<style scoped>
.maquina-card {
  border-radius: 12px;
}

.kpi-pill {
  background: #e9f1ff;
  border-color: transparent;
}

@media (max-width: 1264px) {
  .flex-wrap {
    flex-wrap: wrap !important;
  }
}
</style>
